import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const displayTextRangeResolver: FieldResolver = (metadata: Metadata) =>
  ({ displayTextRange: metadata.getDisplayTextRange() } as StreamData)

export default displayTextRangeResolver
